export const leftPad = (input: number) =>
    input.toString().length === 1 ? ("0" + input).slice(-2) : input.toString();
